import React from 'react';
import { COLORS, FONTS, cardStyle, inputStyle, labelStyle, handleInputFocus, handleInputBlur, primaryButtonStyle, secondaryButtonStyle } from './signupStyles';
import { StepIndicator } from './StepIndicator';
import { TagInput } from './TagInput';
import { CONDITION_SUGGESTIONS, MEDICATION_SUGGESTIONS, INSURANCE_OPTIONS } from './signupData';

const selectStyle = {
  ...inputStyle,
  appearance: 'none',
  backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\'12\' height=\'8\' viewBox=\'0 0 12 8\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cpath d=\'M1 1L6 6L11 1\' stroke=\'%23666\' stroke-width=\'2\' stroke-linecap=\'round\'/%3E%3C/svg%3E")',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'right 16px center'
};

const ToggleButton = ({ selected, onClick, label }) => (
  <button type="button" onClick={onClick} style={{
    padding: '10px 24px', fontSize: '14px', fontWeight: '600', borderRadius: '6px', cursor: 'pointer',
    border: selected ? `2px solid ${COLORS.salmon}` : `1.5px solid ${COLORS.border}`,
    backgroundColor: selected ? `${COLORS.salmon}10` : '#fff',
    color: selected ? COLORS.salmon : COLORS.muted, transition: 'all 0.2s'
  }}>{label}</button>
);

export const StepHealthDetails = ({ formData, onUpdate, onNext, onBack }) => {
  const canContinue = formData.conditions.length > 0 && formData.agreedToTerms;

  return (
    <div style={{
      minHeight: '80vh', backgroundColor: COLORS.bg, display: 'flex',
      alignItems: 'center', justifyContent: 'center', padding: '80px 20px 40px', fontFamily: FONTS.system
    }}>
      <style>{`
        @media (max-width: 480px) {
          .signup-health-card { padding: 32px 24px !important; }
        }
      `}</style>
      <div className="signup-health-card" style={cardStyle}>
        <StepIndicator currentStep={2} totalSteps={4} stepLabels={['Personal', 'About You', 'Health', 'Done']} />
        <h2 style={{ fontFamily: FONTS.serif, fontSize: '24px', fontWeight: '700', color: COLORS.text, margin: '0 0 8px', textAlign: 'center' }}>
          Health Details
        </h2>

        <div style={{
          backgroundColor: `${COLORS.blue}08`, border: `1px solid ${COLORS.blue}20`,
          borderRadius: '6px', padding: '12px 16px', marginBottom: '24px', fontSize: '13px',
          color: COLORS.muted, lineHeight: '1.5'
        }}>
          We use this information to provide you with a better experience and to match you with relevant research projects.
        </div>

        <div style={{ marginBottom: '16px' }}>
          <label style={labelStyle}>Health condition(s)*</label>
          <p style={{ fontSize: '12px', color: COLORS.muted, margin: '-4px 0 8px' }}>
            Search the list by typing. You can add a new one by typing and pressing Enter.
          </p>
          <TagInput values={formData.conditions} onChange={(v) => onUpdate({ conditions: v })}
            suggestions={CONDITION_SUGGESTIONS} placeholder="Search and select conditions" />
        </div>

        <div style={{ marginBottom: '16px' }}>
          <label style={labelStyle}>Medication(s)</label>
          <p style={{ fontSize: '12px', color: COLORS.muted, margin: '-4px 0 8px' }}>
            Search the list by typing. You can add a new one by typing and pressing Enter.
          </p>
          <TagInput values={formData.medications} onChange={(v) => onUpdate({ medications: v })}
            suggestions={MEDICATION_SUGGESTIONS} placeholder="Search and select medications" />
        </div>

        <div style={{ marginBottom: '16px' }}>
          <label style={labelStyle}>My insurance is through...</label>
          <select value={formData.insurance} onChange={(e) => onUpdate({ insurance: e.target.value })}
            style={selectStyle} onFocus={handleInputFocus} onBlur={handleInputBlur}>
            <option value="">Select...</option>
            {INSURANCE_OPTIONS.map(i => <option key={i} value={i}>{i}</option>)}
          </select>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <label style={labelStyle}>Do you have any clinical trial experience?</label>
          <div style={{ display: 'flex', gap: '12px' }}>
            <ToggleButton label="Yes" selected={formData.clinicalTrialExperience === 'Yes'}
              onClick={() => onUpdate({ clinicalTrialExperience: 'Yes' })} />
            <ToggleButton label="No" selected={formData.clinicalTrialExperience === 'No'}
              onClick={() => onUpdate({ clinicalTrialExperience: 'No' })} />
          </div>
        </div>

        <div style={{ marginBottom: '28px' }}>
          <label style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', cursor: 'pointer' }}>
            <input type="checkbox" checked={formData.agreedToTerms}
              onChange={(e) => onUpdate({ agreedToTerms: e.target.checked })}
              style={{ width: '18px', height: '18px', marginTop: '2px', accentColor: COLORS.salmon, cursor: 'pointer' }} />
            <span style={{ fontSize: '13px', color: COLORS.muted, lineHeight: '1.5' }}>
              I acknowledge and accept Real Patients'{' '}
              <a href="/terms" target="_blank" rel="noopener noreferrer" style={{ color: COLORS.blue, fontWeight: '500' }}>Terms of Service</a>
              {' '}and{' '}
              <a href="/privacy" target="_blank" rel="noopener noreferrer" style={{ color: COLORS.blue, fontWeight: '500' }}>Privacy Policy</a>
            </span>
          </label>
        </div>

        <div style={{ display: 'flex', gap: '12px' }}>
          <button onClick={onBack} style={secondaryButtonStyle}>Back</button>
          <button onClick={onNext} disabled={!canContinue} style={{
            ...primaryButtonStyle,
            flex: 1,
            opacity: canContinue ? 1 : 0.4,
            cursor: canContinue ? 'pointer' : 'not-allowed'
          }}>Create Account</button>
        </div>
      </div>
    </div>
  );
};
